import { Box, Button, CircularProgress, Grid, TextField, Typography, } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import axiosClient from "../../../../../../../../../lib/axios";
import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import { formatarInputValorMonetário, formatarMonetárioParaNúmero } from "../../../../../../../../../helpers/masks";
import BtnActionWrapper from "../../../../../../BtnActionWrapper";
import { TLoja } from "../../../../../../../../Comercial/components/MIPedidos/DialogCriarPedidoVenda";
import SelectLoja from "../../../../../../../../../components/SelectsSimpleApiQuery/SelectLoja";
import Pagamento from "./Pagamento";
import AlertMarcarDesconto from "../../AlertMarcarDesconto";
import { IInternForm } from "./Pagamento/DialogCadastrarPag";

export default function RegistrarPagamento() {

    const queryClient = useQueryClient();

    const { getValues, watch, setValue, handleSubmit, control } = useFormContext();

    const handleBack = getValues('funcoesAux.onBack')

    //valores importantes
    const activeStep = watch('stepper')

    const lojaSelect = watch('finalizacao.loja')

    const verificarRegistrarBtn = () => {
        const ultimoStep = activeStep === 2
        const lojaRegistrada = Boolean(watch('finalizacao.loja'))
        const valorRegistrado = watch('finalizacao.pagamentos').length > 0
        return !(ultimoStep && valorRegistrado && lojaRegistrada)
    }
    //

    //queries e mutations
    const { mutate: finalizarRecb, isLoading } = useMutation({
        mutationKey: 'registrar-pagamento-titulos',
        mutationFn: (input: IInputRegPagamento) => axiosClient.post(`financeiro/contas-pagar/registrar-pagamento-titulos`, input),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar(`Erro ao registrar Pagamento`, { variant: "error" })
        },
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries("table-data-grid-financeiro/financeiro/contas-pagar/pesquisar-titulos-pagar")
            enqueueSnackbar(`Pagamento foi realizado com sucesso!`, { variant: "success" })
            const { recebido_por, data_hora, movimentacoes } = data
            const resultado = {
                recebido_por,
                data_hora,
                movimentacoes
            }
            setValue('pagamentoRegistrado', resultado)
        }
    });
    //  

    //Funções manipuladoras
    const handleChangeLoja = (value: TLoja | null) => {
        setValue('finalizacao.loja', value)
    }


    const handleSendRecb = () => {
        const { finalizacao, selecionar_titulos } = getValues()

        const params: IInputRegPagamento = {
            titulos: selecionar_titulos.map((titulo: any) => titulo.id),
            data_pagamento: finalizacao.data_pagamento.format("YYYY-MM-DD"),
            loja_id: finalizacao.loja.id,
            juros: finalizacao.juros === '' ? 0 : formatarMonetárioParaNúmero(finalizacao.juros),
            descontar_diferenca: finalizacao.aplicarDiferencaComoDesconto,
            valores: finalizacao.pagamentos.map((item: IInternForm) => ({
                valor: formatarMonetárioParaNúmero(item.valor),
                forma_recebimento_id: item.formaPagamento?.id,
                ...(item.cartao_nsu ? { nsu: item.cartao_nsu } : {}),
                ...(item.cartao_autorizacao ? { autorizacao: item.cartao_autorizacao } : {}),
                ...(item.cheque_banco ? { cod_banco: item.cheque_banco.codigo } : {}),
                ...(item.cheque_num ? { num_cheque: item.cheque_num } : {}),
            }))
        }

        finalizarRecb(params)
    }
    //

    return (
        <Box maxWidth={600}>
            <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 12}}>
                    <Box paddingTop={2}>
                        <Typography variant='h6'>Registrar pagamento</Typography>
                        <Typography variant='body1' color="gray" mb={2}>(Você informa manualmente a loja e o valor do pagamento)</Typography>
                    </Box>
                </Grid>

                <Grid size={{xs: 6}}>
                    <SelectLoja
                        value={lojaSelect}
                        onChange={(value) => handleChangeLoja(value)}
                        extraParams={{ somente_vinculadas: Boolean(getValues('finalizacao.usuarioComLoja')) }}
                    />
                </Grid>

                <Grid size={{xs: 6}}>
                    <Controller
                        name="finalizacao.juros"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                disabled={!Boolean(lojaSelect)}
                                fullWidth
                                label="Juros"
                                value={field.value}
                                onChange={(e) => {
                                    const formattedValue = formatarInputValorMonetário(e.target.value)
                                    field.onChange(formattedValue);
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid size={{xs: 12}}>
                    <AlertMarcarDesconto />
                    {Boolean(lojaSelect) && <Pagamento />}
                </Grid>
            </Grid>

            <BtnActionWrapper>
                <Button onClick={handleBack} sx={{ pointerEvents: 'auto' }} >
                    Voltar
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit(handleSendRecb)}
                    sx={{ pointerEvents: 'auto' }}
                    disabled={verificarRegistrarBtn() || isLoading}
                >
                    {isLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}
                    Registrar
                </Button>
            </BtnActionWrapper>
        </Box>
    )
}

type IInputRegPagamento = {
    titulos: string[];
    data_pagamento: string;
    loja_id: number;
    juros: number;
    descontar_diferenca?: boolean
    valores: Array<{
        valor: number
        forma_recebimento_id: number,
        autorizacao?: string,
        nsu?: string
    }>
}
